/* eslint-disable sort-keys-fix/sort-keys-fix */
export const defaultColorMap = {
    // grey-125
    grey: '#38444d',
    // grey-15
    lightgrey: '#748088',
    // white
    white: '#ffffff',
    null: '#ffffff',
    // grey-15
    grey15: '#e3e6e7',
    // purple
    deeppurple: '#7300bd',
    0: '#7300bd',
    // sierra
    dullorange: '#c67d35',
    10: '#c67d35',
    brown: '#c67d35',
    // orange
    brightorange: '#ff9610',
    20: '#ff9610',
    // lime-green-200
    brightpalegreen: '#95efbb',
    30: '#95efbb',
    'light-green': '#95efbb',
    // lawn-green
    grassgreen: '#8ef33a',
    40: '#8ef33a',
    green: '#8ef33a',
    // magenta
    brightpurple: '#ff00a5',
    50: '#ff00a5',
    // raspberry-red
    darkred: '#981b35',
    60: '#981b35',
    'dark-red': '#981b35',
    // steel-blue
    paleblue: '#1d2193',
    70: '#1d2193',
    'dark-blue': '#1d2193',
    // deep-sky-blue
    brightblue: '#08aaff',
    80: '#08aaff',
    blue: '#08aaff',
    // light-blue
    brightazure: '#21c9ed',
    90: '#21c9ed',
    'light-blue': '#21c9ed',
    // yellow-old-200
    orangehighlight: '#e4db83',
    100: '#e4db83',
    'light-orange': '#e4db83',
    // spring-green
    brightgreen: '#34cba6',
    110: '#34cba6',
    'mint-green': '#34cba6',
    // firebrick-200
    brightorangehighlight: '#e28985',
    120: '#e28985',
    red: '#e28985',
    // yellow
    khaki: '#f2d420',
    130: '#f2d420',
    yellow: '#f2d420',
    // dark-cyan
    turquoise: '#00a2bd',
    140: '#00a2bd',
    cyan: '#00a2bd',
    // forest-green
    dullazure: '#307646',
    150: '#307646'
}

const GREY_150 = '#293338'
const WHITE = '#fff'

export const defaultForegroundColorMap = {
    // grey-125
    grey: WHITE,
    // grey-15
    lightgrey: GREY_150,
    // white
    white: GREY_150,
    null: GREY_150,
    // grey-15
    grey15: GREY_150,
    // purple
    deeppurple: WHITE,
    0: WHITE,
    // sierra
    dullorange: WHITE,
    10: WHITE,
    brown: WHITE,
    // orange
    brightorange: GREY_150,
    20: GREY_150,
    // lime-green-200
    brightpalegreen: GREY_150,
    30: GREY_150,
    'light-green': GREY_150,
    // lawn-green
    grassgreen: GREY_150,
    40: GREY_150,
    green: GREY_150,
    // magenta
    brightpurple: WHITE,
    50: WHITE,
    // raspberry-red
    darkred: WHITE,
    60: WHITE,
    'dark-red': WHITE,
    // steel-blue
    paleblue: WHITE,
    70: WHITE,
    'dark-blue': WHITE,
    // deep-sky-blue
    brightblue: WHITE,
    80: WHITE,
    blue: WHITE,
    // light-blue
    brightazure: GREY_150,
    90: GREY_150,
    'light-blue': GREY_150,
    // yellow-old-200
    orangehighlight: GREY_150,
    100: GREY_150,
    'light-orange': GREY_150,
    // spring-green
    brightgreen: GREY_150,
    110: GREY_150,
    'mint-green': GREY_150,
    // firebrick-200
    brightorangehighlight: GREY_150,
    120: GREY_150,
    red: GREY_150,
    // yellow
    khaki: GREY_150,
    130: GREY_150,
    yellow: GREY_150,
    // dark-cyan
    turquoise: WHITE,
    140: WHITE,
    cyan: WHITE,
    // forest-green
    dullazure: WHITE,
    150: WHITE
}
